import Theme from '@adsk/alloy-react-theme';

export const infoIconStyle = {
  display: 'inline-block',
  marginRight: '10px',
  color: Theme.colors.charcoal500,
};

export const textContainerStyle = {
  maxWidth: '140px',
  display: 'inline-block',
};

export const permissionSelectContainerStyle = {
  width: '130px',
  display: 'inline-block',
  verticalAlign: 'top',
};

export const permissionIndicatorStyle = {
  'paddingLeft': '10px',
  '> div:last-child': {
    color: Theme.colors.white,
    whiteSpace: 'break-spaces',
  },
};
